import {
  Alert,
  AlertDescription,
  AlertTitle,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { FC } from "react";

import { UrlMappingMatchType } from "~/src/__generated__/schema";

import { KnownUrlMappingMatchType, matchTypeHelp } from "./urlMappingFormUtils";

type Props = {
  matchType: UrlMappingMatchType;
};

export const MatchTypeHelpAlert: FC<Props> = ({ matchType }) => {
  if (matchType === "%future added value") return null;

  const help = matchTypeHelp[matchType as KnownUrlMappingMatchType];
  const status = matchType === "TRANSFORM" ? "warning" : "info";

  return (
    <Alert
      status={status}
      variant="left-accent"
      width="100%"
      borderRadius="4px"
    >
      <AlertDescription fontSize="13px" width="100%">
        <AlertTitle fontSize="14px" mb="4px">
          {help.title}
        </AlertTitle>
        <Text mb="8px">{help.description}</Text>
        <UnorderedList spacing="4px" pl="16px">
          {help.bullets.map((bullet) => (
            <ListItem key={bullet}>{bullet}</ListItem>
          ))}
        </UnorderedList>
        {help.example && (
          <Text
            mt="8px"
            fontFamily="mono"
            fontSize="12px"
            whiteSpace="pre-wrap"
          >
            {help.example}
          </Text>
        )}
      </AlertDescription>
    </Alert>
  );
};
